export var Size;
(function (Size) {
    Size[Size["SM"] = 375] = "SM";
    Size[Size["MD"] = 768] = "MD";
    Size[Size["LG"] = 1280] = "LG";
    Size[Size["XL"] = 1440] = "XL";
    Size[Size["XXL"] = 1920] = "XXL";
})(Size || (Size = {}));
export var breakpoints = {
    // For backward compatibility
    smMax: "max-width: 425px",
    mdMin: "min-width: 426px",
    lgMin: "min-width: 769px",
    // Media queries for breakpoints
    xs: "@media (max-width: 374px)",
    sm: "@media (min-width: ".concat(Size.SM, "px)"),
    smOnly: "@media (min-width: ".concat(Size.SM, "px) and (max-width: 767px)"),
    md: "@media (min-width: ".concat(Size.MD, "px)"),
    mdOnly: "@media (min-width: ".concat(Size.MD, "px) and (max-width: 1279px)"),
    lg: "@media (min-width: ".concat(Size.LG, "px)"),
    lgOnly: "@media (min-width: ".concat(Size.LG, "px) and (max-width: 1439px)"),
    xl: "@media (min-width: ".concat(Size.XL, "px)"),
    xlOnly: "@media (min-width: ".concat(Size.XL, "px) and (max-width: 1919px)"),
    xxl: "@media (min-width: ".concat(Size.XXL, "px)")
};
